import { Localization } from "../../../common/localizable-component";
import { ContextMenuLocalization } from "./context-menu-types";

export const CONTEXT_MENU_LOCALIZATION: Localization<ContextMenuLocalization> = {
  en: {
    openContextMenuInfo: "Click to open context menu list"
  },
  de: {
    openContextMenuInfo: "Bitte anklicken, um das Context Menü zu öffnen"
  },
  sv: {
    openContextMenuInfo: "Klicka för att öppna kontextmenyn"
  },
  nl: {
    openContextMenuInfo: "Klik om de contextmenu te openen"
  },
  it: {
    openContextMenuInfo: "Fai clic per aprire il menu contestuale"
  },
  hu: {
    openContextMenuInfo: "Kattintson a helyi menü megnyitásához"
  },
  da: {
    openContextMenuInfo: "Klik for at åbne kontekstmenuen"
  },
  fr: {
    openContextMenuInfo: "Cliquez pour ouvrir le menu contextuel"
  },
  es: {
    openContextMenuInfo: "Haga clic para abrir el menú contextual"
  },
  pl: {
    openContextMenuInfo: "Kliknij, aby otworzyć menu kontekstowe"
  },
  ro: {
    openContextMenuInfo: "Faceți clic pentru a deschide meniul contextual"
  },
  hr: {
    openContextMenuInfo: "Kliknite za otvaranje kontekstnog izbornika"
  },
  cs: {
    openContextMenuInfo: "Klikněte pro otevření kontextového menu"
  },
  sl: {
    openContextMenuInfo: "Kliknite, da odprete kontekstni meni"
  }
};
